
import React, { useState } from "react";
import "../CSS/services.css";

// import appDev from "../images/app-dev.png";
import digital from "../images/digital.png";
import app from "../images/app.png";
import db from "../images/db.png";
import website from "../images/website.png";
import cloudnew from "../images/cloudnew.png";
import sd from "../images/sd.jpg";
import graphic from "../images/graphic.png";
import tech from "../images/tech.png";
import learn from "../images/learn.png";
const services = [
    {
    id: "software",
    tab: "Custom Software",
    title: "Custom Software",
    desc: "Tailored systems to streamline workflows.",
    image: sd,
  },
  {
    id: "ai",
    tab: "AI Development",
    title: "AI Development",
    desc: "Machine learning pipelines and AI solutions.",

  
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995"
    
  },
  {
    id: "web",
    tab: "Website Design",
    title: "Website Design",
    desc: "Modern responsive websites built for speed and SEO.",
    image: website,
  },
  {
    id: "app",
    tab: "App Development",
    title: "App Development",
    desc: "Secure scalable apps with great performance.",   
     image: app,   // 🔥 variable use kar
  },

  {
    id: "cloud",
    tab: "Cloud Services",
    title: "Cloud Services",
    desc: "Secure cloud infrastructure on AWS/GCP/Azure.",
    image: cloudnew,
  },
  {
    id: "migration",
    tab: "Database Migration",
    title: "Database Migration",
    desc: "Zero downtime migration to modern databases.",
    image: db,
  },
  
  {
    id: "marketing",
    tab: "Digital Marketing",
    title: "Digital Marketing",
    desc: "SEO strategies that convert traffic into leads.",
    // image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa",
    image: digital,
  },
  {
    id: "design",
    tab: "Graphic Design",
    title: "Graphic Design",
    desc: "Brand aligned visuals and creative assets.",
    image: graphic,
  },
  {
    id: "support",
    tab: "Tech Support",
    title: "Tech Support",
    desc: "Reliable monitoring and technical support.",
    image: tech,
  },
  {
    id: "learning",
    tab: "Learning Program",
    title: "Learning Program",
    desc: "Training programs to upskill teams.",
    image: learn,
  },
];

function ServicesPage() {
   const [activeSection, setActiveSection] = useState("");

const scrollToSection = (id) => {
  const element = document.getElementById(id);

  if (!element) return;

  element.scrollIntoView({
    behavior: "smooth",
    block: "start", // 👈 section ka top align karega
  });

  // active border delay (smooth feel ke liye)
  setTimeout(() => {
    setActiveSection(id);
  }, 300);
};
  return (
    <section className="sp-section">
      <div className=" container-fluid ">
        <h2 className="sp-title pt-5 pb-3">Our Services</h2>
        {/* 🔥 TABS */}
        <div className="sp-tabs mt-4">
          {services.map((item) => (
            <button key={item.id} onClick={() => scrollToSection(item.id)}>
              {item.tab}
            </button>            
          ))}
        </div>

        {/*  ALL SECTIONS */}
        {services.map((item, index) => (
          <div
            key={item.id}
            id={item.id}
            className={`sp-flex ${index % 2 !== 0 ? "reverse" : ""} ${activeSection === item.id ? "active-section" : ""}`}
          >
            {/* LEFT */}
            {/* <div className="sp-left">
              <h2 className="sp-heading">{item.title}</h2>
              <p className="sp-main-desc">{item.desc}</p>
            </div> */}

            <div className="sp-left">
              <div className="sp-content">
                <h2 className="sp-heading">{item.title}</h2>
                <p className="sp-main-desc">{item.desc}</p>
              </div>
            </div>

            {/* RIGHT */}
            <div className="sp-right">
              <img src={item.image} alt={item.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicesPage;
